export default "__VITE_ASSET__d8aaeb69__"